module.exports = __webpack_public_path__ + "img/OurVision_Img.1ed7c31e.jpg";